import React from "react";
import "./AppStatsWidget.css";
import WidgetContainer from "../../../components/WidgetContainer/WidgetContainer";

const AppStatsWidget = () => {
    return (
        <WidgetContainer stylesClass="app-stats">
            <div
                className="app-stats-banner"
                title="Pay with PhonePe everywhere you go"
            >
                <div className="app-stats-banner__content">
                    <div className="app-stats-banner__item">
                        <span className="app-stats-banner__item__text">
                            By The <br></br>Numbers
                        </span>
                        <br />
                        <span className="bar"></span>
                    </div>
                    <div className="app-stats-banner__item">
                        <span className="app-stats-banner__item__subtext">
                            Trusted by
                        </span>
                        <br />
                        <span className="app-stats-banner__item__text">
                            230 Million
                        </span>
                        <br />
                        <span className="app-stats-banner__item__subtext">
                            Registered Users
                        </span>
                    </div>
                    <div className="app-stats-banner__item">
                        <span className="app-stats-banner__item__subtext">
                            Accepted in over
                        </span>
                        <br />
                        <span className="app-stats-banner__item__text">
                            500
                        </span>
                        <br />
                        <span className="app-stats-banner__item__subtext">
                            Cities
                        </span>
                    </div>
                    <div className="app-stats-banner__item">
                        <span className="app-stats-banner__item__subtext">
                            Accepted at over
                        </span>
                        <br />
                        <span className="app-stats-banner__item__text">
                            11 Million
                        </span>
                        <br />
                        <span className="app-stats-banner__item__subtext">
                            Stores and more
                        </span>
                    </div>
                </div>
            </div>
        </WidgetContainer>
    );
};

export default AppStatsWidget;
